module.exports = __webpack_public_path__ + "img/SS.17098444.svg";